import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, ButtonToolbar, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

import {
  selectShowConfidenceLevel,
  selectShowInvalidData,
  selectShowValidData,
  setShowConfidenceLevel,
  setShowInvalidData,
  setShowValidData,
} from '@stores/dataVisualizationSlice';

import Authorize from '@awp/components/Authorize';
import { Permissions } from '@awp/constants';
import { selectFullScreen, toggle } from '@awp/stores/fullScreenSlice';
import { TableDataDownloadButton } from '@awp/components/dataTables/helpers/dataProcess';

const PageActions = ({ openValidationModal }) => {
  const dispatch = useDispatch();
  const fullScreen = useSelector(selectFullScreen);
  const showConfidenceLevel = useSelector(selectShowConfidenceLevel);
  const showInvalidData = useSelector(selectShowInvalidData);
  const showValidData = useSelector(selectShowValidData);

  const selectAll = showConfidenceLevel && showInvalidData && showValidData;

  const toggleHeader = () => dispatch(toggle());

  const handleSelectAll = () => {
    if (selectAll) {
      dispatch(setShowConfidenceLevel(false));
      dispatch(setShowInvalidData(false));
      dispatch(setShowValidData(false));
    } else {
      dispatch(setShowConfidenceLevel(true));
      dispatch(setShowInvalidData(true));
      dispatch(setShowValidData(true));
    }
  };

  const checked = <i className="bi bi-check-square text-success mr-2" />;
  const unchecked = <i className="bi bi-square mr-2" />;

  return (
    <ButtonToolbar className="justify-content-end">
      <TableDataDownloadButton
        tableKey="data-tables"
        showConfidenceLevel={showConfidenceLevel}
        showInvalidData={showInvalidData}
        showValidData={showValidData}
      />
      <Button variant="secondary" className="mr-2" onClick={toggleHeader}>
        {fullScreen.enabled ? 'Exit Full Screen' : 'Full Screen'}
      </Button>
      <Dropdown>
        <Dropdown.Toggle variant="primary" id="dropdown_actions_id">
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ width: '18rem' }}>
          <Authorize requires={[Permissions.WriteDataTableManualValidation]}>
            <Dropdown.Item onClick={openValidationModal}>Manual Data Validation</Dropdown.Item>
            <Dropdown.Divider />
          </Authorize>

          <Dropdown.ItemText onClick={handleSelectAll}>{selectAll ? 'Deselect ' : 'Select '}All</Dropdown.ItemText>
          <Dropdown.Divider />
          <Dropdown.ItemText onClick={() => dispatch(setShowConfidenceLevel(!showConfidenceLevel))}>
            {showConfidenceLevel ? checked : unchecked}Confidence Level
          </Dropdown.ItemText>
          <Dropdown.ItemText onClick={() => dispatch(setShowInvalidData(!showInvalidData))}>
            {showInvalidData ? checked : unchecked}Invalid Data
          </Dropdown.ItemText>
          <Dropdown.ItemText onClick={() => dispatch(setShowValidData(!showValidData))}>
            {showValidData ? checked : unchecked}Valid Data
          </Dropdown.ItemText>
        </Dropdown.Menu>
      </Dropdown>
    </ButtonToolbar>
  );
};

PageActions.propTypes = {
  openValidationModal: PropTypes.func,
};
export default PageActions;
